module.exports = __webpack_public_path__ + "static/media/proj15_img13.df3ede6c.jpg";